export enum ObjectStatus {
	New = 0,
	Edited = 10,
	Removed = 20
}